import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showMessage } from 'app/store/fuse/messageSlice';
import { http } from 'lib';

const initialState = {
	searchTerm: '',
	page: 0,
	rowsPerPage: 10,
	orderBy: 'createdAt',
	order: 'desc',
	enquiryUser: {
		response: {},
		loading: false,
		error: ''
	}
};

const enquiryUserSlice = createSlice({
	name: 'user/early-signup',
	initialState,
	reducers: {
		setSearchTerm: (state, { payload }) => {
			state.searchTerm = payload;
		},
		setPage: (state, { payload }) => {
			state.page = payload;
		},
		setRowsPerPage: (state, { payload }) => {
			state.rowsPerPage = payload;
		},
		setOrderBy: (state, { payload }) => {
			state.orderBy = payload;
		},
		setOrder: (state, { payload }) => {
			state.order = payload;
		},
		getEnquiryBegin: state => {
			state.enquiryUser.loading = true;
		},
		getEnquirySuccess: (state, { payload }) => {
			state.enquiryUser.loading = false;
			state.enquiryUser.response = payload;
		},
		getEnquiryFailure: (state, { payload }) => {
			state.enquiryUser.loading = false;
			state.enquiryUser.error = payload;
		},
		resetState: () => ({
			...initialState
		})
	}
});

export const {
	setSearchTerm,
	setPage,
	setRowsPerPage,
	setOrderBy,
	setOrder,
	getEnquiryBegin,
	getEnquirySuccess,
	getEnquiryFailure,
	resetState
} = enquiryUserSlice.actions;

export const getEnquiryUser = createAsyncThunk('document/get-enquiry', async (params, { dispatch }) => {
	dispatch(getEnquiryBegin());
	try {
		const { data } = await http({
			url: '/early-access/enquiry',
			options: { params },
			token: true,
			service: 'cms'
		});
		dispatch(getEnquirySuccess(data));
	} catch (error) {
		dispatch(getEnquiryFailure(error?.response?.data?.message));
		dispatch(
			showMessage({
				message: error?.response?.data?.message,
				variant: 'error'
			})
		);
	}
});

export default enquiryUserSlice.reducer;
